


import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useEffect } from "react";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { showModal } from "../../../features/modal/modalSlice";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import Btn from "../../shared/button/Btn";
import { addOrUpdateBolgeTeklif, deleteBolgeTeklifItem } from "../../../features/bolgedekiTekliflerim/bolgedekiTekliflerimSlice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;
  .modal {
    width: 600px;
    max-height: 600px;
    overflow: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;

    .content {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 50px;
      flex-direction: column;
      justify-content: space-between;

      p{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: ${({theme}) => theme.mainTextColor};
        text-align: center;
      }

      .btn-container{
        display: flex;
        justify-content: center;
        gap: 20px;
        margin-top: 30px;
      }


    }
  }
`;

const UpdatePermissionCloseBolgedekiTeklifModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { modalLocation } = useSelector((state) => state.modal);

  const { lockScroll, unlockScroll } = useScrollLock();
  const {bolgedekiTeklifler, constantBolgedekiTeklifler, hiddenAracColumnList } = useSelector(state => state.bolgedekiTekliflerim)

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleSubmit = () => {
    //! bu aynı mı değil mi diye?
    const filtered = bolgedekiTeklifler.filter((item) => {
      const jsonString1 = JSON.stringify(item);
      const jsonString2 = JSON.stringify(constantBolgedekiTeklifler.find(innerItem => innerItem.id === item.id));
      return jsonString1 !== jsonString2
    }).filter(item => {
      return (item.fromTownId && item.toTownId && typeof item.id !== "string")
    })


    //! bu mevcutta yoksa ve yeni eklenmişse
    const addedList = bolgedekiTeklifler.filter((item) => {
      return typeof item.id === "string" && item.fromTownId && item.toTownId
    }).map(item => {
      return {...item, id:null}
    })

    


    dispatch(addOrUpdateBolgeTeklif([...filtered, ...addedList]))

  }

  return (
    <Container  onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
        <div className="content">
            <p>Yaptığınız değişiklikleri kaydetmek ister misiniz?</p>
            <div className="btn-container">
                <Btn bgColor="#E85546" color="#fff" width={"220px"} handleClick={handleSubmit}>Değişiklikleri Kaydet</Btn>
                <Btn bgColor="#fff" color="#E85546" borderColor="#E85546" width={"220px"} handleClick={() => dispatch(showModal(null))}>Kaydetme</Btn>
            </div>
        </div>
      </div>
    </Container>
  );
};

export default UpdatePermissionCloseBolgedekiTeklifModal